import { useMemo } from 'react';
import { BudgetRecipientEnum } from '../../createAndEdit/types';
import { BudgetStatusEnum } from '../../../../enums/budgetStatus';
import { useConsultantDetailJourney } from './useConsultantDetailJourney';
import { useFactoryDetailJourney } from './useFactoryDetailJourney';
import { useManagerDetailJourney } from './useManagerDetailJourney';

interface IUseDetailJourneySelectorParams {
  userProfile?: BudgetRecipientEnum | string;
  budgetRecipient?: BudgetRecipientEnum | string;
  budgetStatus?: BudgetStatusEnum | string;
  isLastVersion?: boolean;
}

export const useDetailJourneySelector = (params: IUseDetailJourneySelectorParams) => {
  const { userProfile, budgetRecipient, budgetStatus, isLastVersion } = params;

  const consultantJourney = useConsultantDetailJourney({
    userProfile,
    budgetRecipient,
    budgetStatus,
    isLastVersion,
  });

  const factoryJourney = useFactoryDetailJourney({
    userProfile,
    budgetRecipient,
    budgetStatus,
    isLastVersion,
  });

  const managerJourney = useManagerDetailJourney({
    userProfile,
    budgetRecipient,
    budgetStatus,
    isLastVersion,
  });

  const activeJourney = useMemo(() => {
    switch (userProfile) {
      case BudgetRecipientEnum.CONSULTANT:
        return consultantJourney;
      case BudgetRecipientEnum.TOWER:
        return factoryJourney;
      case BudgetRecipientEnum.MANAGER:
        return managerJourney;
      default:
        return consultantJourney;
    }
  }, [userProfile, consultantJourney, factoryJourney, managerJourney, isLastVersion]);

  return {
    activeJourney,
    isConsultant: consultantJourney.isConsultant,
    isFactory: factoryJourney.isFactory,
    isManager: managerJourney.isManager,
  };
};

